import { CATEGORY_QUERY_PARAM } from './category-filter';

const PAGE_QUERY_PARAM = `page`;

const appendPageNumber = (string, page) => {
  const PAGE_REGEX = /page (\d+)/;

  const match = string.match(PAGE_REGEX);

  if (match) {
    return string.replace(PAGE_REGEX, `page ${page}`);
  }

  return `${string} — page ${page}`;
};

const updateMeta = (newPage) => {
  const $descriptions = document.querySelectorAll(
    `meta[property="og:description"],
    meta[name="twitter:description"],
    meta[name="description"],
    meta[property="og:title"],
    meta[name="twitter:title"],
    title`,
  );

  [...$descriptions].forEach(($description) => {
    if ($description.content) {
      $description.content = appendPageNumber($description.content, newPage);
    }

    if ($description.textContent) {
      $description.textContent = appendPageNumber($description.textContent, newPage);
    }
  });
};

const updateLinks = (newHref, hasMoreItems) => {
  const url = new URL(newHref);
  const page = getPage(newHref);
  let $linkToPreviousPage = document.querySelector(`link[rel="prev"]`);
  const $canonical = document.querySelector(`link[rel="canonical"]`);
  const $ogUrl = document.querySelector(`meta[property="og:url"]`);

  if ($canonical) {
    $canonical.href = newHref;
  }

  if ($ogUrl) {
    $ogUrl.content = newHref;
  }

  if (!$linkToPreviousPage) {
    $linkToPreviousPage = document.createElement(`link`);
    $linkToPreviousPage.setAttribute(`rel`, `prev`);

    document
      .querySelector(`link[rel="canonical"]`)
      .insertAdjacentElement(`beforebegin`, $linkToPreviousPage);
  }

  url.searchParams.set(PAGE_QUERY_PARAM, page - 1);

  if (page - 1 === 1) {
    url.searchParams.delete(PAGE_QUERY_PARAM);
  }

  $linkToPreviousPage.href = url.href;

  const linkToNextPage = document.querySelector(`link[rel="next"]`);

  if (!linkToNextPage) {
    return;
  }

  if (!hasMoreItems) {
    linkToNextPage.remove();
  }

  url.searchParams.set(PAGE_QUERY_PARAM, page + 1);

  linkToNextPage.href = url.href;
};

export const getPage = (pageHref) => {
  const url = new URL(pageHref ?? window.location.href);

  return parseInt(url.searchParams.get(PAGE_QUERY_PARAM) ?? 1, 10);
};

export const getNextPageUrl = () => {
  const url = new URL(window.location.href);
  url.searchParams.set(PAGE_QUERY_PARAM, getPage() + 1);

  return url.href;
};

export const setPage = (page, hasMore) => {
  const url = new URL(window.location.href);

  page ? url.searchParams.set(PAGE_QUERY_PARAM, page) : url.searchParams.delete(PAGE_QUERY_PARAM);

  updateMeta(page ?? 1);
  updateLinks(url.href, hasMore);

  history.replaceState(null, ``, url.href);
};
